<ng-container *transloco="let t">
  <sis-common-attainment-details [attainment]="attainment" [secondaryAttainments]="secondaryAttainments">
    <ng-template *ngIf="expirationImminent" #expirationNotification>
      <sis-attainment-expiration-notification [attainment]="attainment"></sis-attainment-expiration-notification>
    </ng-template>
    <ng-template #thesisInformation>
      <sis-thesis-details [attainment]="attainment"></sis-thesis-details>
    </ng-template>
    <ng-template *ngIf="attainment?.creditTransferInfo" #creditTransferInformation>
      <sis-attainment-credit-transfer-info-details [creditTransferInfo]="attainment.creditTransferInfo">
      </sis-attainment-credit-transfer-info-details>
    </ng-template>
    <ng-template #registrationDetails>
      <div class="form-group-mimic" role="listitem">
        <dt>{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.REGISTRATION_DATE') }}</dt>
        <dd>{{ attainment.registrationDate | localDateFormat }}</dd>
      </div>
    </ng-template>

    <ng-template #curriculumPeriods>
      <div sis-curriculum-periods-details class="form-group-mimic" role="listitem" [attainment]="attainment"></div>
    </ng-template>

    <ng-template #rdiCredits>
      <div *ngIf="rdiCreditsEnabled === 'ENABLED' && attainment.rdiCredits" class="form-group-mimic" role="listitem">
        <dt>{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS') }}</dt>
        <dd>
          {{ attainment.rdiCredits }}
        </dd>
      </div>
      <div *ngIf="rdiCreditsEnabled === 'ENABLED' && !attainment.rdiCredits" class="form-group-mimic" role="listitem">
        <dt>{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS') }}</dt>
        <dd> - </dd>
      </div>
      <div *ngIf="rdiCreditsEnabled === 'DISABLED' && attainment.rdiCredits" class="form-group-mimic" role="listitem">
        <dt>{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS') }}</dt>
        <dd>
          {{ attainment.rdiCredits }}
        </dd>
      </div>
    </ng-template>
  </sis-common-attainment-details>
  <div class="grade-raise-info" *ngIf="gradeRaiseAttemptEnabled && (gradeRaiseEnabled || gradeRaiseInfoEnabled)">
    <fudis-heading [level]="3">{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_TITLE') }}</fudis-heading>
    <ng-container *ngIf="!isAttachedToPrimaryAttainment">
      @if(!isCrossStudyCourseUnit) {
        <ng-container *ngIf="gradeRaiseEnabled">
          <p *ngIf="completionMethodsAvailable && !gradeRaiseAttempt" class="sis-mt-sm sis-mb-sm">{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_HELP_TEXT') }}</p>
          <ng-container *ngIf="gradeRaiseCourseUnitVersion$ | async as data">
            <p *ngIf="completionMethodsAvailable && gradeRaiseAttempt" class="sis-mt-sm sis-mb-sm">{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_ONGOING_HELP_TEXT', { completionMethodIndex: getCompletionMethodIndexForGradeRaise(data) }) }}</p>
          </ng-container>
          <div *ngIf="!completionMethodsAvailable" class="sis-mb-sm">
            <sis-contextual-notification variant="warning">{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_WARNING_TEXT') }}</sis-contextual-notification>
          </div>
          <fudis-button *ngIf="completionMethodsAvailable" [size]="'small'" [variant]="'tertiary'" [label]="t(gradeRaiseButtonTranslationKey())" (handleClick)="this.modalRef.close({ openSelectCompletionMethodModal: true })"></fudis-button>
        </ng-container>
        <ng-container *ngIf="gradeRaiseInfoEnabled">
          <fudis-body-text [variant]="'lg-light'">
            {{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_1') }}
            <a fudisLink
               [title]="t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_LINK_TITLE')"
               [href]="planHref"
               (click)="modalRef.close()"
            ></a>
            {{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_2') }}
          </fudis-body-text>
        </ng-container>
      } @else {
        <fudis-body-text class="sis-mb-sm" variant="lg-light">{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_CROSS_STUDY_1') }}</fudis-body-text>
        <sis-contextual-notification variant="warning">
          {{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_GUIDANCE_CROSS_STUDY_2') }}
        </sis-contextual-notification>
      }
    </ng-container>
    <ng-container *ngIf="isAttachedToPrimaryAttainment">
      <p class="sis-mt-sm sis-mb-sm">{{ t('ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_HELP_TEXT_BASE') }}</p>
      <sis-contextual-notification variant="warning">
        <span translate="ATTAINMENTS.ATTAINMENT_DETAILS.GRADE_RAISE_ATTEMPT_HAS_PARENT_ATTAINMENT"></span>
      </sis-contextual-notification>
    </ng-container>
  </div>
</ng-container>
